import Vue from 'vue'
import ElementUI, { Dialog } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Dialog.props.appendToBody.default = true

Vue.use(ElementUI)
